import type { RefObject } from "react";
import { useMemo } from "react";
import { useTurnstile } from "@/hooks/useTurnstile";

export function useContactFormTurnstile() {
  const turnstileSiteKey = useMemo(() => {
    const v = import.meta.env.VITE_TURNSTILE_SITE_KEY;
    return typeof v === "string" && v.trim() ? v.trim() : null;
  }, []);

  const { containerRef, turnstileReady, getToken, reset, loadError } = useTurnstile(turnstileSiteKey);

  return {
    turnstileSiteKey,
    containerRef,
    turnstileReady,
    getToken,
    resetTurnstile: reset,
    turnstileLoadError: loadError,
  };
}

type ContactFormTurnstileProps = {
  containerRef: RefObject<HTMLDivElement>;
  loadError: string | null;
};

export function ContactFormTurnstile({ containerRef, loadError }: ContactFormTurnstileProps) {
  return (
    <div className="flex flex-col gap-2 mb-6">
      <span className="text-slate-300 text-sm font-medium">CAPTCHA</span>
      <div
        ref={containerRef}
        className="flex min-h-[65px] w-full justify-center rounded-lg border border-slate-600 bg-slate-950/50 py-2"
      />
      {loadError ? <p className="text-sm leading-snug text-amber-400">{loadError}</p> : null}
    </div>
  );
}
